
import { API_END_POINT } from "../../../constants";
import { Button, Modal } from "react-bootstrap";
import '../../../components/Style/ProductInvoiceStyle.css';
import React, { useEffect, useState } from "react";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import { useGetSubGroupProductInvoice } from "../../../apiclient/transaction/useGetSubGroupProductInvoiceApi";
import { SubGroupWiseProduct } from "../../../models/transaction/productinvoice-model";
import { MinusIcon, PlusIcon } from "../../../assets/images/edit";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import DeleteIcon from "../../../assets/images/delete";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { formatDate } from "@progress/kendo-intl";
import { SubGroupWiseProductPurchase } from "../../../models/transaction/purchase-model";
import { useGetUnionPurchaseList } from "../../../apiclient/transaction/useGetUnionsListApi";
import PurchaseInvoiceHistoryModel from "../../../models/transaction/purchasehistory-model";
import '@progress/kendo-theme-default/dist/all.css';

interface PurchaseEditProps {
    data: PurchaseInvoiceHistoryModel;
    onClose?: () => void;
    setActivePage: (page: "list" | "entry") => void;
    //onClose?: (status: SubmitStatus, data: any) => any;
}

const PurchaseEntryPage: React.FC<PurchaseEditProps> = ({ data, setActivePage }) => {

    const editData = data;
    console.log("editData", editData);

    const [purchaseDate, setpurchaseDate] = useState<Date>(new Date(dayjs().add(0, "months").format("MM/DD/YYYY")));
    const [purchaseDate2, setpurchaseDate2] = useState<string>("");
    const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string>("");
    const [modalLine1, setModalLine1] = useState("");
    const [modalLine2, setModalLine2] = useState("");
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [subGroupProductList, setSubGroupProductList] = useState<SubGroupWiseProductPurchase[]>([]);
    const [addedProducts, setAddedProducts] = useState<Set<string>>(new Set());
    const [productList, setProductList] = useState<SubGroupWiseProductPurchase[]>([]);
    const [invoiceNo, setInvoiceNo] = useState<string>("");
    const [unionId, setUnionId] = useState<number>(0);
    const [unionList, setUnionList] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedUnion } = useGetUnionPurchaseList();
    const [subGroupId, setSubGroupId] = useState<number>(0);
    const [subGroupList, setSubGroupList] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedSubGroup } = useGetSubGroupProductInvoice();
    const [showModal, setShowModal] = useState(false);

    const [page, setPage] = useState({ skip: 0, take: 10 });
    const [subGroupPage, setSubGroupPage] = useState({ skip: 0, take: 10 });
    useEffect(() => {
        setSubGroupPage({ skip: 0, take: 10 });
    }, [subGroupProductList]);

    const handleDateChange = (value: any) => {
        // const today = new Date();
        const day = value.getDate().toString().padStart(2, '0');
        const month = value.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
        const year = value.getFullYear();
        const formattedDate = new Date(`${year}-${month}-${day}`);
        setpurchaseDate(formattedDate);
    };
    useEffect(() => {
        if (purchaseDate) {
            const formattedDate1 = dayjs(purchaseDate).format('ddd MMM DD YYYY ');
            console.log("Formatted Date:", formattedDate1);
            setpurchaseDate2(formattedDate1);
        }

    }, [purchaseDate]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === 'invoiceNo') {
            setInvoiceNo(value);
        }
    };
    console.log("fetchedSubGroup", fetchedSubGroup)

    useEffect(() => {
        if (fetchedUnion) {
            const mappedUnions = fetchedUnion.map((unions: any) => ({
                value: unions.unionId,
                label: unions.name,
            }));
            setUnionList(mappedUnions);
        }
        if (fetchedSubGroup) {
            const mappedsubgroup = fetchedSubGroup.map((subgroups: any) => ({
                value: subgroups.subGroupId,
                label: subgroups.subGroupName,
            }));
            setSubGroupList(mappedsubgroup);
        }
    }, [fetchedUnion, fetchedSubGroup])

    const handleuniondropdownChange = (event: { target: { value: any; }; }) => {
        setUnionId(event.target.value);
        console.log("unionId", event.target.value);
    };

    useEffect(() => {
        if (editData.purchaseInvoiceMainId) {
            setpurchaseDate(editData.orderDate2);
            setInvoiceNo(editData.invoiceNumber);
            setUnionId(editData.unionId);
            // setOrderDate(zoneData.orderDate2);
            // const parsedProducts = zoneData.productInvoiceLineDetailsParsed || [];
            setProductList(editData.purchaseInvoiceLineDetailsParsed);
            const added = new Set(editData.purchaseInvoiceLineDetailsParsed.map((product: any) => product.code));
            setAddedProducts(added);
        }
    }, [editData.purchaseInvoiceMainId]);

    const handlesubgroupdropdownChange = (event: { target: { value: any; }; }) => {
        setSubGroupId(event.target.value);
        console.log("subGroupId", event.target.value);
        getSubGroupWiseProductList(event.target.value, purchaseDate2);
    };

    const getSubGroupWiseProductList = async (subGroupId: number, date: string) => {
        console.log("subGroupId1", subGroupId);
        if (subGroupId) {
            const getSubGroupProdudtUrl = getEndPoint(API_END_POINT.ORDER) + `/api/PurchaseInvoice/GetProductsBySubGroup/${subGroupId}/${date}`; // Base URL
            try {
                const response = await getDataWithToken<any>(getSubGroupProdudtUrl);

                const subGroupProductDetails = response?.data?.result;
                console.log("subGroupProductDetails", subGroupProductDetails);
                if (subGroupProductDetails.length > 0) {
                    setSubGroupProductList(subGroupProductDetails);
                    const subGrpProdLidt = subGroupProductDetails[0];
                    //setAgentId(subGrpProdLidt?.agentId);
                    //setdroppingpointid(subGrpProdLidt?.droppingPointId);

                } else {
                    alert("No Data Found")
                    setSubGroupProductList([]);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                //setShowGrid(false);
            }
        }
    }

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleAddButtonClick = (props: any) => {
        console.log("props:", props);
        console.log("add", addedProducts);
        const newAddedProducts = new Set(addedProducts);
        console.log("addnew", newAddedProducts);
        //alert(newAddedProducts.has(props.code));
        if (newAddedProducts.has(props.code)) {
            setProductList(productList.filter(item => item.code !== props.code));
            newAddedProducts.delete(props.code);
        } else {
            const newProduct = {
                ...props,
                qty: "",
                amount: "0",
                cGst: "0",
                sGst: "0",
                iGst: "0"
            };
            setProductList([...productList, newProduct]);
            newAddedProducts.add(props.code);
            // setProductList([...productList, props]);
            // newAddedProducts.add(props.code);
        }
        setAddedProducts(newAddedProducts); // Update the added products set
    };

    // console.log('produ', productList);

    const handleRemoveProduct = (indexToRemove: number) => {
        //setProductList(prevList => prevList.filter((_, index) => index !== indexToRemove));
        const removedProduct = productList[indexToRemove];
        const updatedProductList = productList.filter((_, index) => index !== indexToRemove);
        const updatedAddedProducts = new Set(addedProducts);
        console.log("updatedAddedProducts", updatedAddedProducts);
        updatedAddedProducts.delete(removedProduct.code);
        setProductList(updatedProductList);
        setAddedProducts(updatedAddedProducts);
    };

    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [receivedAmount, setReceivedAmount] = useState('');

    // const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: string) => {
    //     const updatedList = [...productList];
    //     const updatedItem = updatedList[index];

    //     let value = Number(e.target.value);
    //     if (isNaN(value) || value < 0) {
    //         value = 0;  // Set to 0 if invalid or negative
    //     }
    //     if (type === 'qty') {
    //         updatedItem.qty = value;
    //     } else if (type === 'basicRate') {
    //         updatedItem.basicRate = value;
    //     }
    //     updatedItem.amount = ((Number(updatedItem.qty)) * Number(updatedItem.basicRate));
    //     if (updatedItem.isOtherState == false) {
    //         updatedItem.cGst = ((Number(updatedItem.qty)) * Number(updatedItem.cgstRate));
    //         updatedItem.sGst = ((Number(updatedItem.qty)) * Number(updatedItem.sgstRate));
    //     } else {
    //         updatedItem.iGst = ((Number(updatedItem.qty)) * Number(updatedItem.igstRate));
    //     }
    //     updatedList[index] = updatedItem;
    //     setProductList(updatedList);
    //     calculateTotalAmount(updatedList);
    // };

    const calculateTotalAmount = (data: any[]) => {
        console.log("Data:", data);
        const total = data.reduce((sum, item) => {
            const amount = parseFloat(item.amount);
            console.log("sum:", amount);
            return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        console.log("total a:", total)
        setTotalAmount(total);
        setReceivedAmount(total.toFixed(2));
    };

    const handleSaveButtonClick = async () => {
        console.log("prod", productList);

        const purchaseInvoice = {
            PurchaseInvoiceMainId: editData.purchaseInvoiceMainId,
            TenantId: 1,
            OrderGroupId: 0,
            OrderDate: purchaseDate2,
            DeliveryDate: purchaseDate2,
            SessionId: 0,
            OrderNumber: invoiceNo,
            OrderType: 1,
            GrnNo: editData.grnNo,
            GrnDate: purchaseDate2,
            InvoiceNumber: invoiceNo,
            InvoiceDate: purchaseDate2,
            UnionId: unionId,
            //AgentId: productList[0].agentId,
            CategoryId: productList[0].categoryId,
            GatePassNumber: "0",
            DcNumber: "0",
            GSTIn: "0",
            UserId: 0,
            OrderQty: productList.reduce((sum, p) => sum + p.qty, 0),
            OrderAmount: totalAmount,
            // BasicAmount: 850.0, // example
            // CGSTAmount: 75.0,
            // SGSTAmount: 75.0,
            // IGSTAmount: 0.0,
            // TotalTax: 150.0,
            RoundingAdjustment: 0.0,
            NetAmount: totalAmount,
            CreatedBy: 1,
            ModifiedBy: 1,
            Lines: productList.map(product => ({
                PurchaseInvoiceLineId: product.purchaseInvoiceLineId || 0,
                PurchaseInvoiceMainId: product.purchaseInvoiceMainId || 0, // set later in DB
                ProductId: product.productId,
                MainGroupId: product.mainGroupId,
                SubGroupId: product.subGroupId,
                HSNCode: product.hsnCode,
                ProductName: product.productName,
                ProductShortName: product.productShortName,
                BaseUnitId: product.baseUnitId,
                SubUnitId: product.subUnitId,
                UnitQty: product.unitQty,
                Quantity: product.qty,
                //LiterOrKilo: product.unitQty * product.qty, // if applicable
                //GSTPerecentage: product.gstPercentage,
                BasicRatePerUnit: product.basicRate,
                CGSTPerecentage: product.cgstPercentage,
                // CGSTRatePerUnit: product.cgstRate,
                CGSTRatePerUnit: product.cGst,
                SGSTPerecentage: product.sgstPercentage,
                // SGSTRatePerUnit: product.sgstRate,
                SGSTRatePerUnit: product.sGst,
                IGSTPerecentage: product.igstPercentage,
                // IGSTRatePerUnit: product.igstRate,
                IGSTRatePerUnit: product.iGst,
                RatePerUnit: product.basicRate + product.cgstRate + product.sgstRate,
                Amount: product.basicRate * product.qty,
                //CGSTAmount: product.cgstRate * product.qty,
                // SGSTAmount: product.sgstRate * product.qty,
                // IGSTAmount: product.igstRate * product.qty,
                TotalAmount: totalAmount,
                CommisionAmount: 0.0,
                CreatedBy: 1,
                ModifiedBy: 1
            }))
        };
        console.log("productInvoice", purchaseInvoice);

        if (purchaseDate) {
            setLoadingDetails(true);
            try {
                setpurchaseDate(purchaseDate);
                //setCustomerCode(customerCode);
                const response = await postData<any>(API_END_POINT.ORDER,
                    "PurchaseInvoice/SavePurchaseInvoice",
                    "POST",
                    "application/json",
                    purchaseInvoice,
                );
                console.log("res", response);
                //alert(response);
                if (response.status === 200) {
                    //alert("Order Saved Successfully.");
                    const isUpdate = productList.some(p => p.purchaseInvoiceMainId && p.purchaseInvoiceMainId !== 0);
                    setIsUpdateMode(isUpdate);
                    if (isUpdate) {
                        setModalTitle("Order Updated");
                        setModalLine1("Order Updated Successfully");

                    } else {
                        setModalTitle("Order Successfully");
                        setModalLine1("Order Saved Successfully");
                        // setModalLine2("Do you want to print this invoice?");
                    }
                    setShowModal(true);
                    setInvoiceNo('');
                    setUnionId(0);
                    setSubGroupId(0);
                    setSubGroupProductList([]);
                    setProductList([]);
                    setAddedProducts(new Set());
                }
                else {
                    alert("Failed to Confirm the Order.");
                }

            } catch (error) {
                console.error("Error fetching product details:", error);
            } finally {
                // setLoadingDetails(false);
            }
        } else {
            alert("Please select a customercode");

        }
    };
    // const handleItemChange = (e: any) => {
    //     const updated = [...productList];
    //     const index = updated.findIndex((item) => item.productId === e.dataItem.productId);
    //     if (index !== -1) {
    //         updated[index] = {
    //             ...updated[index],
    //             [e.field]: e.value
    //         };
    //         setProductList(updated);
    //     }
    // };

    const handleRowClick = (event: any) => {
        const updated = productList.map((item) =>
            item.productId === event.dataItem.productId
                ? { ...item, inEdit: true }
                : { ...item, inEdit: false }
        );
        setProductList(updated);
    };



    const handleItemChange = (e: any) => {
        const updated = [...productList];
        const index = updated.findIndex((item) => item.productId === e.dataItem.productId);

        if (index !== -1) {
            const field = e.field;
            const value = Number(e.value) >= 0 ? Number(e.value) : 0;
            const currentItem = { ...updated[index], [field]: value };
            currentItem.qty = field === 'qty' ? value/* Math.min(Math.max(Number(value), 0), 9999) */ : Number(currentItem.qty) || 0;
            currentItem.basicRate = field === 'purchaseCost' ? value : Number(currentItem.purchaseCost) || 0;
            currentItem.amount = currentItem.qty * currentItem.basicRate;
            currentItem.cGst = ((Number(currentItem.amount)) * Number(currentItem.cgstPercentage) / 100);
            currentItem.sGst = ((Number(currentItem.amount)) * Number(currentItem.sgstPercentage) / 100);
            currentItem.iGst = ((Number(currentItem.amount)) * Number(currentItem.igstPercentage) / 100);

            // currentItem.cGst = currentItem.isOtherState == false ?
            //     (currentItem.cGst = ((Number(currentItem.qty)) * Number(currentItem.cgstRate)),
            //         currentItem.sGst = ((Number(currentItem.qty)) * Number(currentItem.sgstRate)))
            //     : currentItem.iGst = ((Number(currentItem.qty)) * Number(currentItem.igstRate));

            /*   if (currentItem.isOtherState == false) {
                  currentItem.cGst = ((Number(currentItem.qty)) * Number(currentItem.cgstRate));
                  currentItem.sGst = ((Number(currentItem.qty)) * Number(currentItem.sgstRate));
              } else {
                  currentItem.iGst = ((Number(currentItem.qty)) * Number(currentItem.igstRate));
              } */


            updated[index] = currentItem;
            setProductList(updated);
        }
    };

    // const ItemChange = (event: GridItemChangeEvent) => {
    //     const updatedList = productList.map((item) =>
    //         item.productId === event.dataItem.productId
    //             ? { ...item, [event.field]: event.value }
    //             : item
    //     );
    //     setProductList(updatedList);
    // };
    /*  console.log("subGroupProductList length:", subGroupProductList.length);
     console.log("Page take:", subGroupPage.take); */

    return (
        <><div>
            <center>
                <h4 className="text-normal title-web mb-0 report-title-color">
                    PURCHASE INVOICE
                </h4>
            </center>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">

                <div className="d-flex" style={{ marginTop: "-50px", marginLeft: "20px" }}>
                    <div className="me-2" style={{ width: '150px' }}>
                        <label>Purchase Date</label>
                        <DatePicker
                            name="purchaseDate"
                            selectsMultiple={true}
                            openToDate={new Date()}
                            className="form-control ms-auto search-right-align calendarBg"
                            value={formatDate(purchaseDate, "dd-MM-yyyy")}
                            placeholderText="Order"
                            dateFormat={"dd/MM/yyyy"}
                            onChange={([date]: any) => {
                                setpurchaseDate(date);
                                handleDateChange(date);
                            }} />
                    </div>
                    {/*   <div className="me-2" style={{ width: '110px' }}>
        <label>Code</label>
        <input
            name="unionCode"
            value={unionCode}
            onChange={handleChange}
            className="sessioninput"
        ></input>
    </div> */}
                    <div className="me-2" style={{ width: '200px' }}>
                        <label>Unions</label>
                        <select
                            value={unionId}
                            onChange={handleuniondropdownChange}
                            className="sessioninput"
                            style={{ width: '100%', }}
                        >
                            <option value="0">Please Select</option>
                            {unionList.map((option) => (
                                <option key={option.label} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="me-2" style={{ width: '150px' }}>
                        <label>InvoiceNo</label>
                        <input
                            name="invoiceNo"
                            value={invoiceNo}
                            onChange={handleChange}
                            className="sessioninput"
                        ></input>
                    </div>
                  {/*   <div className="me-2">
                        <button
                            className="btn btn-primary btn-sm"
                            style={{ height: '36px', marginTop: '20px' }}
                            onClick={handleSaveButtonClick}
                        >
                            Save
                        </button>
                    </div> */}
                    <div className="mt-3" style={{ marginLeft: "630px" }}>
                        <Button
                            className="btn btn-secondary"
                            onClick={() => setActivePage("list")} // Changed from "agentliterorderpage" to "list"
                        >
                            ← Back
                        </Button>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                {/* <div style={{ flex: '0 0 100%' }}> */}
                <div style={{ flex: '0 0 68%', height: 'auto', overflow: 'visible', marginTop: "-43px" }}>
                    {productList.length > 0 && (
                        <><Grid
                            data={productList.slice(page.skip, page.skip + page.take)}
                            style={{ height: 'auto' }}
                            editField='inEdit'
                            dataItemKey='productId'
                            pageable={{ pageSizes: [10, 20, 50, 100] }}
                            //groupable={true}
                            skip={page.skip}
                            take={page.take}
                            total={productList?.length}
                            onPageChange={(e) => setPage({ skip: e.page.skip, take: e.page.take })}
                            // className='tableWrapper'
                            /*  onItemChange={ItemChange} */
                            onItemChange={handleItemChange}
                            onRowClick={handleRowClick}
                        >
                            <Column
                                title=""
                                width="50px"
                                cell={(props) => (
                                    <td>
                                        <button
                                            className="action-btns k-grid-remove-command"
                                            onClick={() => handleRemoveProduct(props.dataIndex)}
                                        >
                                            <DeleteIcon />
                                        </button>
                                    </td>
                                )} />
                            <Column field="code" title="Code" width="60px" editable={false} />
                            <Column field="productName" title="Product Name" width="200px" editable={false} />
                            <Column field='basicRate' title='Rate' width="100px" editable={true} editor='text' format="{0:n2}" className="right-align" />
                            <Column field='qty' title='Qty' width="100px" editable={true} className="right-align"
                                editor='text' format="{0:n3}"
                                /*  cell={(props) => (
                                     <td style={{ textAlign: "right" }}>
                                         {props.dataItem.qty}
                                     </td>
                                 )} */
                                footerCell={() => (
                                    <td className="footer-align">
                                        {productList.reduce((sum, item) => sum + (Number(item.qty) || 0), 0).toFixed(3)}
                                    </td>
                                )} />
                            <Column
                                field="cGst"
                                title="CGST"
                                width="90px"
                                editable={true}
                                editor='text'
                                className="right-align"
                                format="{0:n2}" />
                            <Column
                                field="sGst"
                                title="SGST"
                                width="100px"
                                editable={true}
                                editor='text'
                                className="right-align"
                                format="{0:n2}" />
                            <Column
                                field="iGst"
                                title="IGST"
                                width="100px"
                                editable={true}
                                editor='text'
                                className="right-align"
                                format="{0:n2}" />
                            <Column
                                field="amount"
                                title="Amount"
                                width="100px"
                                editable={false}
                                editor='text'
                                className="right-align"
                                format="{0:n2}"
                                // cell={(props) => <td className="right-align">{(parseFloat(props.dataItem.amount) || 0).toFixed(2)}</td>}
                                footerCell={() => (
                                    <td className="footer-align">
                                        {productList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0).toFixed(2)}
                                    </td>
                                )} />
                        </Grid><div className="me-2">
                                <button
                                    className="btn btn-primary btn-sm"
                                    style={{ height: '36px', marginTop: '20px',marginLeft: "850px" }}
                                    onClick={handleSaveButtonClick}
                                >
                                    Save
                                </button>
                            </div></>
                    )}
                </div>

                <div style={{ flex: '0 0 28%', height: 'auto', marginTop: "-43px" }}>
                    <div className="purchase-order-container" style={{ marginLeft: '-1px' }}>
                        <div className="toolbar">
                            {/*  <span className="k-spacer"></span> */}
                            <label htmlFor="SubGroup">
                                SubGroup:
                            </label>
                            <select
                                value={subGroupId}
                                onChange={handlesubgroupdropdownChange}
                                className="sessioninput"
                                style={{ width: '72%', marginLeft: '15px', marginTop: '10px' }} // Adjust width to 100% for responsiveness
                            >
                                <option value="0">Please Select</option>
                                {subGroupList.map((option) => (
                                    <option key={option.label} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                        </div>

                        {subGroupProductList.length > 0 && (
                            <Grid
                                style={{ marginLeft: '-75px', marginTop: '5px' }}
                                /*  style={{ minWidth: '500px' }} */
                                data={subGroupProductList.slice(subGroupPage.skip, subGroupPage.skip + subGroupPage.take)}
                                skip={subGroupPage.skip}
                                take={subGroupPage.take}
                                total={subGroupProductList.length}
                                pageable={{
                                    pageSizes: [10, 20, 50, 100],
                                    buttonCount: 5,
                                    info: true,
                                    previousNext: true
                                }}
                                onPageChange={(e) => setSubGroupPage({ skip: e.page.skip, take: e.page.take })}
                            >
                                <Column field="code" title="Code" width="75px" />
                                <Column field="productName" title="Product Name" width="265px" />
                                <Column
                                    width="50px"
                                    cell={(props) => {
                                        return (
                                            <td>
                                                <button
                                                    style={{ border: "none", background: "transparent", padding: 0 }}
                                                    onClick={() => handleAddButtonClick(props.dataItem)}
                                                >
                                                    {addedProducts.has(props.dataItem.code) ? <MinusIcon /> : <PlusIcon />}
                                                </button>
                                            </td>
                                        );
                                    }} />

                            </Grid>
                        )}
                    </div>
                </div>

                <div style={{ marginTop: 15 }}>
                    <Modal style={{ alignContent: "center" }} show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h6>{modalLine1}</h6>
                            <h6>{modalLine2}</h6>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handleCloseModal}>
                                OK
                            </Button>
                            {/* {isUpdateMode ? (
                                <Button variant="primary" onClick={handleCloseModal}>
                                    OK
                                </Button>
                            ) : (
                                <>
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        Back
                                    </Button>
                                </>
                            )} */}
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div >
            {/* <div className="mt-3" style={{ marginLeft: '20px' }}>
                <Button
                    className="btn btn-secondary"
                    onClick={() => setActivePage("list")} // Changed from "agentliterorderpage" to "list"
                >
                    ← Back
                </Button>
            </div> */}</>

        /*  </div > */
    );
}
export default PurchaseEntryPage;
